import React, { useEffect } from "react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { onLogin, onLoginWithToken } from "../../redux/homeAction";
import { toast } from "react-toastify";
import Loader from "../loader/Loader";
import SocialLogin from "../SocialLogin/SocialLogin";

const Login = () => {
  const [value, setValue] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const inputHandler = (e) => {
    setValue({ ...value, [e.target.name]: e.target.value });
  };

  const emailRegex =
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('verified') === 'true') {
      toast.success('Email verified successfully!');
    } else if (params.get('loginAsToken')) {
      const token = params.get('loginAsToken');
      dispatch(onLoginWithToken(token, navigate, setLoader));
      params.delete('loginAsToken');
      window.history.replaceState({}, '', `${window.location.pathname}?${params}`);
    }
  }, [dispatch, navigate, setLoader]);

  const onSubmitLogin = (e) => {
    e.preventDefault();
    if (!value.email) {
      toast.error("please enter a email");
    } else if (!emailRegex.test(value.email)) {
      toast.error("please enter a correct gmail");
    } else if (!value.password) {
      toast.error("please enter a password");
    } else if (value.password.length < 4) {
      toast.error("The password must be at least 4 characters");
    } else {
      setLoader(true);
      const data = {
        email: value.email,
        password: value.password,
      };
      dispatch(onLogin(data, navigate, setLoader));
    }
  };

  return (
    <>
      <section id="login">
        <div className="login_content">
          <div className="row gy-5">
            <div className="col-lg-6 d-flex justify-content-center align-items-center">
              <div className="login-container">
                <div className="text-start mb-3">
                  <Link to="/" className="back-button">
                    <i className="fas fa-arrow-left me-2"></i>Back
                  </Link>
                </div>
                <div className="text-center">
                  <h1>
                    Welcome to <span className="color_yellow">Triunfador</span>
                  </h1>
                </div>
                
                <SocialLogin 
                  onSuccess={(result) => {
                    dispatch({
                      type: 'ONLOGIN',
                      payload: result
                    });
                  }}
                  onError={(error) => {
                    setLoader(false);
                    toast.error(error.message);
                  }}
                />

                <div className="divider">
                  <span>or</span>
                </div>

                <form onSubmit={onSubmitLogin}>
                  <div className="row gy-3">
                    <div className="col-md-12">
                      <div className="form-group floating">
                        <input
                          type="email"
                          className="form-control floating input"
                          name="email"
                          value={value.email}
                          onChange={(e) => inputHandler(e)}
                          required
                        />
                        <label htmlFor="usr">E-mail address</label>
                        <div className="input_icon">
                          <i className="fa-regular fa-envelope" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group floating position-relative mb-3">
                        <input
                          type={`${showPassword ? "text" : "password"}`}
                          className="form-control floating input"
                          name="password"
                          value={value.password}
                          onChange={(e) => inputHandler(e)}
                          required
                        />
                        <label htmlFor="usr">Password</label>
                        <div className="input_icon">
                          {showPassword ? (
                            <i
                              className="fa-regular fa-eye"
                              onClick={() => setShowPassword(false)}
                            />
                          ) : (
                            <i
                              className="fa fa-eye-slash"
                              onClick={() => setShowPassword(true)}
                            ></i>
                          )}
                        </div>
                        <Link className="forgetpasword" to="/forget-password">
                          Forgot Password ?
                        </Link>
                      </div>
                    </div>
                    <div className="col-md-12">
                      {loader ? (
                        <Loader />
                      ) : (
                        <input type="submit" className="input submit_input" value="Play Now" />
                      )}
                    </div>
                  </div>
                </form>
                <Link to="/register" className="text_normal">
                  Not Registered yet ?
                  <span className="color_yellow">Create an Account</span>
                </Link>
              </div>
            </div>
            <div className="col-lg-6 d-flex align-items-center">
              <div className="login_right">
                <img src="./images/login_right.png" className="img-fluid" alt="Login" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Login;
